import type { ListBuilderList } from '../../../types';
import { createVehicleColumns } from '../columns';

/**
 * Maintenance/Inactive vehicles list configuration
 * Shows vehicles that are in maintenance or inactive status
 */
export const unavailableVehiclesList: ListBuilderList = {
	id: 'default-vehicles-unavailable',
	name: 'Maintenance/Inactive',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		vehicleStatus: {
			defaultValue: [
				{ id: 'inactive', label: 'Inactive' },
				{ id: 'maintenance', label: 'Maintenance' },
				{ id: 'offline', label: 'Offline' },
			],
		},
	},
	columns: createVehicleColumns(),
	defaultSortId: 'vehicle-name',
	sortOrder: 3,
};
